import mapData from '../data/map-data.json'; 
import uniqBy from 'lodash/uniqBy';

//Check if exists and belongs to the given prefix
const ifValidKey = (prefix, key, item) => {
  return (item[key] && item[key] !== '' && key.indexOf(prefix)===0 && item[key] )
}

//Parse every row
const parseItem = (item) => {
  //Main properties
  const newItem = {
    name: item.name,
    status: item.status,
    beneficiaries: item.beneficiaries,
    size: item.size,
    link: item.link,
    origin: [],
    destination: [],
    skillLevel: [],
    skillType: [],
  };

  Object.keys(item).forEach(key => {

    //Origin country fields
    if(ifValidKey("origin", key, item)){
      newItem.origin.push(parseCountry(item[key]));
    }

    //Destination country fields
    if(ifValidKey("destination", key, item)){
      newItem.destination.push(parseCountry(item[key]));
    }

    //Skills Level fields
    if(ifValidKey("skill_level", key, item)){
      newItem.skillLevel.push(item[key]);
    }

    //Skills Type fields
    if(ifValidKey("skill_type", key, item)){
      newItem.skillType.push(item[key]);
    }

  });

  return newItem;
}


const parseCountry = (countryToParse) => {
  try {
    const [label, iso_a3] = countryToParse.split('.');
    return {
      value: countryToParse,
      label,
      iso_a3,
    };
  } catch (error) {
    console.error('countryToParse',countryToParse);
  }

  return countryToParse;
};

const getCountries = (data) => {
  let countries = [];

  data.forEach((pathway) => {
    countries = countries.concat(
      [ ...pathway.destination,
        ...pathway.origin
      ]);
  });

  return uniqBy(countries, 'iso_a3')
    .filter((country) => country.value !== 'All countries.ALL')
    .sort( (a,b) => a.label>b.label?1:-1);
}

const getUniqueAndFormattedSkills = (skills) => {
  return [...new Set(skills.flat())]
  .filter((skill) =>  skill !== 'Not specified')
  .map((skill) => ({
    label: skill,
    value: skill,
  }));
}

// group skills by country
const getSectorsByCountry = (data, countries) => {
  const sectors = {};
  countries?.forEach((country) => {
    // get all skills present in pathways which include the given country
    const skills = data
      .filter((pathway) => (pathway.origin.some(origin => origin.value === country.value) ||  pathway.destination.some(destination => destination.value === country.value)))
      .map((pathway) => pathway.skillType);

    // get unique, not repeated, skills
    sectors[country.value] = getUniqueAndFormattedSkills(skills);
  });
  
  return sectors;
}

//Get data action
export const getData = async () => {
  const pathways = mapData.map(i => parseItem(i));
  const countries = getCountries(pathways);
  const sectorsByCountry = getSectorsByCountry(pathways, countries);

  return {
    pathways,
    countries,
    sectorsByCountry,
  };
};



export const mockMapData = [
  {
    "name": "Program 1",
    "destinations": [
      {
        "country": "Argentina",
        "iso_a3": "ARG"
      },
      {
        "country": "Belgium",
        "iso_a3": "BEL"
      },
    ],
    "origins": [
      {
        "country": "Canada",
        "iso_a3": "CAN"
      },
      {
        "country": "Haiti",
        "iso_a3": "HTI"
      },
    ]
  },
  {
    "name": "Program 2",
    "destinations": [
      {
        "country": "Honduras",
        "iso_a3": "HND"
      }
    ],
    "origins": [
      {
        "country": "Ireland",
        "iso_a3": "IRL"
      },
      {
        "country": "Lithuania",
        "iso_a3": "LTU"
      },
    ]
  },
  {
    "name": "Program 3",
    "destinations": [
      {
        "country": "Honduras",
        "iso_a3": "HND"
      }
    ],
    "origins": [
      {
        "country": "Argentina",
        "iso_a3": "ARG"
      },
    ]
  },
  {
    "name": "Program 4",
    "destinations": [
      {
        "country": "Lithuania",
        "iso_a3": "LTU"
      },
    ],
    "origins": [
      {
        "country": "Argentina",
        "iso_a3": "ARG"
      },
    ]
  },
]
